import React from 'react'
import { Radio } from 'atoms/Radio'
import translate from 'core/translate'
import { cn } from 'ethcss'
import styles from './deviceSettings__syncContent.jcss'
import { Typography } from 'atoms/Typography'
import { SwitchButton } from '../../../atoms/SwitchButton'

const DeviceSettingsSyncContent = (p_: {
    enabled: boolean
    type: string
    value: boolean
    className: string | object
    onChange: (value: any, field: string) => void
}) => {
    if (!p_.enabled) {
        return null
    }

    const description =
        p_.type === 'group' ? translate('syncContentDescription') : translate('syncDeviceContentDescription')

    return (
        <div className={cn(p_.className)}>
            <div className={styles.switchWrapper}>
                <SwitchButton
                    checked={p_.value}
                    onChange={() => {
                        p_.onChange(!p_.value, 'syncContent')
                    }}
                    className={`test-settings-toggle_${p_.value ? 'enabled' : 'disabled'}`}
                />
                <div className={cn(styles.switchCaption)}>
                    <Typography className={cn(styles.title)} type="title">
                        {translate('syncContent')}
                    </Typography>
                </div>
            </div>
            <div className={styles.hint}>{description}</div>
        </div>
    )
}

DeviceSettingsSyncContent.defaultProps = {
    value: false,
}

export default React.memo(DeviceSettingsSyncContent)
